/** The six user-facing levels; Pi's internal minimal level is not exposed. */
export const MODEL_THINKING_LEVELS = [
  'off',
  'low',
  'medium',
  'high',
  'xhigh',
  'max',
] as const;
export type ModelThinkingLevel = (typeof MODEL_THINKING_LEVELS)[number];
export type ModelThinkingMap = Partial<
  Record<ModelThinkingLevel | 'minimal', string | null>
>;

/** Explicit selections replace support, while retaining native wire values for supported levels. */
export function declaredThinkingMap(
  levels: readonly ModelThinkingLevel[],
  catalog?: ModelThinkingMap
): ModelThinkingMap {
  return Object.fromEntries([
    ['minimal', null],
    ...MODEL_THINKING_LEVELS.map(level => [
      level,
      levels.includes(level)
        ? (catalog?.[level] ?? (level === 'off' ? undefined : level))
        : null,
    ]),
  ]);
}

/** Same ordered preference as Pi: next supported level, otherwise the highest below it. */
export function selectThinkingLevel(
  requested: ModelThinkingLevel,
  supported: readonly ModelThinkingLevel[]
): ModelThinkingLevel {
  if (supported.includes(requested)) return requested;
  const index = MODEL_THINKING_LEVELS.indexOf(requested);
  return (
    MODEL_THINKING_LEVELS.slice(index).find(level =>
      supported.includes(level)
    ) ??
    [...MODEL_THINKING_LEVELS]
      .reverse()
      .find(level => supported.includes(level)) ??
    'off'
  );
}
